import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Map from 'immutable';
import {
  _change_speed_order_modal,
  _dssp_send_click,
  _new_room_window,
} from '../../store/Action';
import { Modal, message } from 'antd';
import HTTP from '../../script/service';
import Util from '../../script/util';
import './index.scss';

class SpeedOrderModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      orderList: [], //点单类型
    };
  }
  // 是否更新数据
  componentDidUpdate(prevProps, prevState, snapshot) {
    const props1 = Map.fromJS(prevProps.base.speedOrderModal);
    const props2 = Map.fromJS(this.props.base.speedOrderModal);

    if (!this.props.base.speedOrderModal) {
    } else if (this.props.base.speedOrderModal && !Map.is(props1, props2)) {
      this.getOrderType();
    }
  }

  hideModal = () => {
    this.setState({ visible: false });
    _change_speed_order_modal({
      speedOrderModal: false,
    });
  };
  getOrderType = () => {
    HTTP._get_order_type().then((res) => {
      if (res?.code === 200) {
        this.setState({
          visible: true,
          orderList: res.data || [],
        });
      }
    });
  };

  //随机房间
  randomRoom = (dispatchType) => {
    let params = {
      dispatchType,
    };
    _dssp_send_click(9);
    HTTP._get_order_random_room(params).then((res) => {
      if (res?.code === 200) {
        if (res.data.roomId) {
          _new_room_window(
            {
              roomid: res.data.roomId,
            },
            this.props.history
          );
        }
      } else {
        message.warning(res.message);
      }
    });
  };

  render() {
    const { visible, orderList } = this.state;
    return (
      <Modal
        open={visible}
        wrapClassName="daidai-modal-order-style"
        centered={true}
        title=""
        footer={null}
        keyboard={false}
        width="290px"
        onCancel={this.hideModal}
      >
        <div className="order-modal-wrap">
          <div className="order-modal-box">
            {orderList?.map((item, index) => (
              <div
                className="order-modal-item"
                key={index}
                onClick={() => this.randomRoom(item.dispatchType)}
              >
                <img src={Util.transImgUrl(item.pcImg, '416x140')} alt="" />
              </div>
            ))}
          </div>
        </div>
      </Modal>
    );
  }
}

export default connect((store) => ({ base: store }))(SpeedOrderModal);
